'use strict';

import React from 'react';
import { toast } from 'react-toastify';

import { Toaster } from '../components/index.jsx';

export function showToaster(title, body, autoClose = 2000, color = 'primary') {
	toast(<Toaster title={title} body={body} color={color} />, { autoClose: autoClose });
}
